import React from "react"
import { useTranslation } from "react-i18next"
import { faClose, faLink } from "@fortawesome/free-solid-svg-icons"
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons"
import ModalPortal from "../../../../components/Modal/ModalPortal"
import defaultStyle from "../../../../styles/defaultPageStyle.module.css"
import InputField from "../../../../components/InputField/InputField"
import Button, { ButtonIcon } from "../../../../components/Button/Button"
import { TitlePageResponsiveIconSmall } from "../../../../components/Titles/Titles"
import THEME from "../../../../configuration/Theme"
import { SIZE } from "../../../../configuration/Sizes"
import Animate, { AnimationTypes } from "../../../../components/Animate/Animate"
import type { IWhatsAppPairingCodeResult } from "../../../../Objects/WhatsAppAutomation/WhatsAppAgentOverview"

type Props = {
  isOpen: boolean
  agentName: string
  onClose: () => void
  onChangeAgentName: (value: string) => void
  onGeneratePairing: () => void
}

export const WhatsAppPairingPopup: React.FC<Props> = ({
  isOpen,
  agentName,
  onClose,
  onChangeAgentName,
  onGeneratePairing,
}) => {
  const { t } = useTranslation(["pages", "buttons"])

  if (!isOpen) {
    return null
  }

  return (
    <ModalPortal>
      <div className={defaultStyle.overlay}>
        <Animate type={AnimationTypes.slideUpIn} duration="0.3s">
          <div className={defaultStyle.alert}>
            <TitlePageResponsiveIconSmall
              iconColor={THEME.colors.iconBGColor}
              title={t("label_whatsapp_automation_pairing_popup_title")}
              icon={faWhatsapp}
              subtitleChildren={
                <ButtonIcon
                  sizeNumber={SIZE.buttonCloseIconSize}
                  bgColor={THEME.colors.buttonBGCloseColor}
                  iconColor={THEME.colors.buttonFGCloseColor}
                  icon={faClose}
                  onClick={onClose}
                  size="small"
                  descriptionKey="interactionDescriptions:pages.myRestaurant.whatsAppAutomation.components.whatsAppPairingPopup.button.onClose"
                />
              }
            />

            <Animate type={AnimationTypes.fadeInTraslate} duration="1.5s">
              <div className="mt-4 p-2 grid gap-3">
                <InputField
                  type="text"
                  value={agentName}
                  icon={faLink}
                  title={t("label_whatsapp_automation_agent_name")}
                  onChange={(event) => onChangeAgentName(event.target.value)}
                  placeholder={t("label_whatsapp_automation_agent_name")}
                  required
                  descriptionKey="interactionDescriptions:pages.myRestaurant.whatsAppAutomation.components.whatsAppPairingPopup.input.whatsappAutomationAgentName"
                />

                <Button
                  bgColor={THEME.colors.buttonBGSaveColor}
                  label={t("label_print_automation_generate_pairing")}
                  onClick={() => {
                    onClose()
                    onGeneratePairing()
                  }}
                  disabled={!agentName.trim()}
                  descriptionKey="interactionDescriptions:pages.myRestaurant.whatsAppAutomation.components.whatsAppPairingPopup.button.printAutomationGeneratePairing"
                />

                <div className="rounded-lg border-2 border-green-200 bg-slate-50 p-3 text-xs text-slate-600">
                  <strong className="block text-slate-800">
                    {t("label_whatsapp_automation_pairing_popup_note_title")}
                  </strong>
                  <p className="mt-1">{t("label_whatsapp_automation_pairing_popup_note_description")}</p>
                </div>
              </div>
            </Animate>
          </div>
        </Animate>
      </div>
    </ModalPortal>
  )
}
